export default "__VITE_ASSET__DfSFdGxN__"